import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Form, Button, Modal, Table } from 'react-bootstrap'
import { api, getBranchOwner, get, post, put } from "@config"
import { setLoading } from "@inspinia-react/actions"
import { setIpi } from '@taxes/actions'

import enqTable from './table.json'
import { FormControl } from 'react-bootstrap'
import { mapTest } from '../../../products/map.test'
import { checkIfBranchExists } from '../../../../../utils'

const cstEntries = [
    { value: "", label: 'Selecione' },
    { value: "00", label: 'Entrada com Recuperação de Crédito' },
    { value: "01", label: 'Entrada Tributada com Alíquota Zero' },
    { value: "02", label: 'Entrada Isenta' },
    { value: "03", label: 'Entrada Não Tributada' },
    { value: "04", label: 'Entrada Imune' },
    { value: "05", label: 'Entrada com Suspensão' },

    { value: "49", label: 'Outras Entradas' },
    { value: "50", label: 'Saída Tributada' },
    { value: "51", label: 'Saída Tributável com Alíquota Zero' },
    { value: "52", label: 'Saída Isenta' },
    { value: "53", label: 'Saída Não Tributada' },
    { value: "54", label: 'Saída Imune' },
    { value: "55", label: 'Saída com Suspensão' },
    { value: "99", label: 'Saída Isenta' }
]

class CreateIPI extends React.Component {
    constructor(props) {
        super(props)
        checkIfBranchExists()
        this.state = {
            showModal: false,
            data: {},
            enqCodeList: [],
            ipiList: []
        }
        this.onCloseModal = this.onCloseModal.bind(this)
        this.openModal = this.openModal.bind(this)
        this.onChangeIpi = this.onChangeIpi.bind(this)
        this.onIpiHasSaved = this.onIpiHasSaved.bind(this)
        this._setState = this._setState.bind(this)
        this.setItem = this.setItem.bind(this)
        this.onSave = this.onSave.bind(this)
    }

    getIpiList() {
        const { id } = getBranchOwner()
        const payload = ipiList => this.setState({ ...this, ipiList })
        get(`${api.ipi}?branch_owner=${id}`, payload)
    }

    updateListCEnq(cst) {
        let tempList = []
        const imune = (cst === "04" || cst === "54")
        const suspension = (cst === "05" || cst === "55")
        const isention = (cst === "02" || cst === "52")

        if (imune) {
            tempList = enqTable['imunidade']
        } else if (suspension) {
            tempList = enqTable['suspensao']
        } else if (isention) {
            tempList = enqTable['isencao']
        } else {
            tempList = enqTable['outros']
        }
        this.setState({ ...this, enqCodeList: tempList })
    }

    _setState(e) {
        const { data } = this.state
        const { name: key, value } = e.target
        data[key] = value
        if (key === "cst") {
            this.updateListCEnq(value)
        }
        this.setState(...this, data)
    }

    onCloseModal() {
        if (this.props.onCancel) {
            this.props.onCancel()
        }
        this.setState({ ...this, showModal: false })
    }
    openModal() {
        this.setState({ ...this, showModal: true })
    }

    setItem(item) {
        let { data } = this.state
        data = item
        data.edit = true

        const e = {
            target: {
                "name": "cst",
                "value": item.cst
            }
        }

        this._setState(e)

        this.setState({ ...this, data, showModal: true })
    }

    onChangeIpi(e) {
        let newIpi = this.state.ipiList[e.currentTarget.selectedIndex - 1]
        console.log(newIpi)
        this.props.setIpi(newIpi)
    }

    onIpiHasSaved(ipi) {
        this.getIpiList()
        this.setState({ ...this, showModal: false, ipiList: [] })
        this.props.setIpi(ipi)
    }
    onSave() {
        const { id } = getBranchOwner()
        const { data } = this.state
        data.calculo = 0
        if (data.edit) {
            put(`${api.ipi}${data.id}/?branch_owner=${id}`, data, this.onIpiHasSaved)
        } else {
            post(`${api.ipi}?branch_owner=${id}`, data, this.onIpiHasSaved)
        }
    }

    componentDidMount() {
        this.getIpiList()
    }

    render() {
        return <React.Fragment>
            {
                this.props.as === "select" ? <React.Fragment>
                    <p className="lead">
                        Selecionar IPI
                    </p>
                    <select disabled={this.props.loading} id={mapTest.createProduct.ipi.select} name="ipi_select" className="form-control" onChange={this.onChangeIpi}>
                        <option value="none">
                            Selecionar
                        </option>
                        {
                            this.state.ipiList.map((ipi) => <option selected={this.props.ipi.id === ipi.id} key={ipi.id} value={ipi.id}>{ipi.name}</option>)
                        }
                    </select>

                    <Button size="sm" onClick={this.openModal}>
                        Criar Template
                    </Button>
                </React.Fragment> : <React.Fragment>
                    <Button size="sm" onClick={this.openModal}>
                        Criar Template
                    </Button>
                    <DisplayList
                        items={this.state.ipiList}
                        onClick={this.setItem}
                    />

                </React.Fragment>
            }


            <Modal show={this.state.showModal} onHide={this.onCloseModal}>
                <Modal.Header closeButton>
                    <h2>
                        {this.state.data.edit? "Editar" : 'Criar'} Template IPI
                    </h2>
                </Modal.Header>
                <Modal.Body className="py-2">
                    <div className="form-group">
                        <p className="m-0 p-0">
                            Nome
                        </p>
                        <FormControl name="name" onChange={this._setState} value={this.state.data.name} disabled={this.props.loading} />
                    </div>
                    <Form.Group>
                        <Form.Label>
                            CST
                        </Form.Label>
                        <Form.Control
                            name="cst"
                            value={this.state.data.cst}
                            onChange={this._setState}
                            as="select"
                            disabled={this.props.loading}
                        >
                            {cstEntries.map(i => <option selected={this.state.data.cst === i.code} key={i.value} value={i.value} >{i.value} - {i.label}</option>)}

                        </Form.Control>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>
                            Código de enquadramento
                        </Form.Label>
                        <Form.Control
                            name="c_enq"
                            value={this.state.data.c_enq}
                            onChange={this._setState}
                            as="select"
                            disabled={this.props.loading || !this.state.data.cst}
                        >
                            <option value="">{!this.state.data.cst ? "Primeiro selecione o cst" : "Selecione"}</option>
                            {this.state.enqCodeList.map(i => <option key={i.code} value={i.code} >{i.code} - {i.description}</option>)}

                        </Form.Control>
                    </Form.Group>
                    <div className="form-group">
                        <p className="m-0 p-0">
                            Aliquota
                        </p>
                        <FormControl name="p_ipi" type='number' onChange={this._setState} value={this.state.data.p_ipi} disabled={this.props.loading} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button disabled={this.props.loading} variant="success" onClick={this.onSave}>
                        Salvar
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    }
}

export function DisplayList(props) {

    return <Table striped bordered hover responsive>
        <thead>
            <tr>
                <th>Nome</th>
                <th>Enquadramento</th>
                <th>Alíquota</th>
                <th>Ações</th>
            </tr>
        </thead>
        <tbody>
            {
                props.items.map(item => <tr key={item.id}>
                    <td>
                        {item.name}
                    </td>
                    <td>
                        {item.c_enq}
                    </td>
                    <td>
                        {item.p_ipi}
                    </td>
                    <td>
                        <Button
                            size="sm"
                            onClick={e => props.onClick(item)}
                            className="m-0 p-0 p-1">
                            <i className="fas fa-edit"></i>
                        </Button>
                    </td>
                </tr>)
            }
        </tbody>
    </Table>
}

const mapStateToProps = state => ({
    loading: state.loading,
    ipi: state.ipi
})
const mapDispatchToProps = dispatch => bindActionCreators({
    setLoading,
    setIpi
}, dispatch)

class EditIPINFE extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            data: {},
            enqCodeList: []
        }

        this._setState = this._setState.bind(this)
        this.onEdit = this.onEdit.bind(this)
    }

    updateListCEnq(cst) {
        let tempList = []
        const imune = (cst === "04" || cst === "54")
        const suspension = (cst === "05" || cst === "55")
        const isention = (cst === "02" || cst === "52")

        if (imune) {
            tempList = enqTable['imunidade']
        } else if (suspension) {
            tempList = enqTable['suspensao']
        } else if (isention) {
            tempList = enqTable['isencao']
        } else {
            tempList = enqTable['outros']
        }
        this.setState({ ...this, enqCodeList: tempList })
    }

    onEdit() {
        if (this.props.onChange) {
            this.props.onChange({...this.state.data, calculo: 0})
        }
    }


    _setState(e) {
        const { data } = this.state
        const { name: key, value } = e.target
        data[key] = value
        if (key === "cst") {
            let list = []
            const imune = (value === "04" || value === "54")
            const suspension = (value === "05" || value === "55")
            const isention = (value === "02" || value === "52")

            if (imune) {
                list = enqTable['imunidade']
            } else if (suspension) {
                list = enqTable['suspensao']
            } else if (isention) {
                list = enqTable['isencao']
            } else {
                list = enqTable['outros']
            }
            this.setState({ ...this, enqCodeList: list })
        }
        this.setState(...this, data)
    }

    componentDidMount() { 
        this.setState({ data: this.props.data })
        setTimeout(() => {
            this.updateListCEnq(this.state.data.cst)
        }, 200);
    }

    render() {
        return (
            <div>
                <div className="form-group">
                    <p className="m-0 p-0">
                        Nome
                    </p>
                    <FormControl name="name" onChange={this._setState} value={this.state.data.name} disabled={this.props.loading} />
                </div>
                <Form.Group>
                    <Form.Label>
                        CST
                    </Form.Label>
                    <Form.Control
                        name="cst"
                        value={this.state.data.cst}
                        onChange={this._setState}
                        as="select"
                    >
                        {cstEntries.map(i => <option selected={this.state.data.cst === i.code} key={i.value} value={i.value} >{i.value} - {i.label}</option>)}

                    </Form.Control>
                </Form.Group>
                <Form.Group>
                    <Form.Label>
                        Código de enquadramento
                    </Form.Label>
                    <Form.Control
                        name="c_enq"
                        value={this.state.data.c_enq}
                        onChange={this._setState}
                        as="select"
                        disabled={!this.state.data.cst}
                    >
                        <option value="">{!this.state.data.cst ? "Primeiro selecione o cst" : "Selecione"}</option>
                        {this.state.enqCodeList.map(i => <option selected={this.state.data.c_enq == i.code} key={i.code} value={i.code} >{i.code} - {i.description}</option>)}

                    </Form.Control>
                </Form.Group>
                <div className="form-group">
                    <p className="m-0 p-0">
                        Base de Cálculo
                    </p>
                    <FormControl name="bc_ipi" type='number' onChange={this._setState} value={this.state.data.bc_ipi} />
                </div>
                <div className='row'>
                    <div className="form-group col-sm-12 col-lg-6">
                        <p className="m-0 p-0">
                            Aliquota (%)
                        </p>
                        <FormControl name="p_ipi" type='number' onChange={this._setState} value={this.state.data.p_ipi} />
                    </div>
                    <div className="form-group col-sm-12 col-lg-6">
                        <p className="m-0 p-0">
                            Valor
                        </p>
                        <FormControl name="v_ipi" type='number' onChange={this._setState} value={this.state.data.v_ipi} />
                    </div>
                </div>

                <Button onClick={this.onEdit} >
                    Salvar
                </Button>

            </div>
        )
    }
}

export { EditIPINFE }
export default connect(mapStateToProps, mapDispatchToProps)(CreateIPI)


// WEBPACK FOOTER //
// ./src/components/pages/fiscal/taxes/ipi/index.jsx